const HAS_TIMEZONE = /(?:Z|[+-]\d{2}:?\d{2})$/;

const EST_FORMAT = new Intl.DateTimeFormat("en-US", {
  timeZone: "America/New_York",
  month: "2-digit",
  day: "2-digit",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit",
  hour12: true,
});

/**
 * Formats a status history timestamp as MM/DD/YYYY HH:MM AM/PM in Eastern time.
 * @param raw - The raw timestamp string from the BFF.
 * @returns {string} The EST-formatted timestamp.
 */
export function formatStatusHistoryDate(raw: string): string {
  if (!raw) {
    return "";
  }
  if (!HAS_TIMEZONE.test(raw)) {
    return raw;
  }
  const parsed = new Date(raw);
  if (Number.isNaN(parsed.getTime())) {
    return raw;
  }
  const parts = new Map(EST_FORMAT.formatToParts(parsed).map((part) => [part.type, part.value]));
  return `${parts.get("month")}/${parts.get("day")}/${parts.get("year")} ${parts.get("hour")}:${parts.get("minute")} ${parts.get("dayPeriod")}`;
}
